import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TextHelperService } from '../../services/text-helper.service';

@Component({
  selector: 'app-modal-content',
  templateUrl: './modal-content.component.html',
  styleUrls: ['./modal-content.component.scss'],
})
export class ModalContentComponent implements OnInit {
  @Input() public item;
  @Input() public path;

  constructor(public activeModal: NgbActiveModal, private textHelperService: TextHelperService) {}

  ngOnInit() {}

  swapPronouns = (input) => {
    return this.textHelperService.swapPronouns(input, this.path);
  };
}
